import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function comboio(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@comboio/FIND_COMBOIO':
      case '@comboio/UPDATE_COMBOIO':
      case '@comboio/DELETE_COMBOIO':
      case '@comboio/STORE_COMBOIO':
      case '@comboio/COMBOIOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@comboio/SUCCESS_REMOVE':
      case '@comboio/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@comboio/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.comboios;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@comboio/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.comboio;
        break;
      }

      case '@comboio/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
